module.exports = __webpack_public_path__ + "img/00_banner_title.8e7fbbf6.png";